import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../auth/login.service';

/**
 * Auth guard – side‑effect free (no immediate navigate()), returns UrlTree when blocking.
 * Preserves the kívánt cél útvonalat redirect paraméterben, hogy sikeres login után oda lehessen visszairányítani.
 */
export const authGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): boolean | UrlTree => {
    const auth = inject(LoginService);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        return true;
    }

    // tároljuk a kívánt URL-t query param-ban
    return router.createUrlTree(['/auth/login'], {
        queryParams: { redirect: state.url }
    });
};